export const messages = {
  selected: 'Selected',
};
